import { Product } from "~/types";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";
import styles from "./HotDealCard.module.css";
import Skeleton from "react-loading-skeleton";
import { Hidden } from "../Hidden/Hidden";
import { Color } from "../Text/Text";

export const HOT_DEAL_CARD_HEIGHT = 150;

export interface HotDealCardProps {
  product: Product;
  onSelect(product: Product): void;
}

export function HotDealCard(props: HotDealCardProps): React.ReactElement {
  const { product, onSelect } = props;

  const disabled = product && !product?.available;

  // priceDescription: e.g. $5 Off, $25.99!, etc.
  const [description, priceDescription] = disabled
    ? ["Currently unavailable"]
    : (product.description || "").trim().split("\n");

  return (
    <Box
      border="dashed"
      borderColor={disabled ? "primary-highlight" : "primary"}
      borderRadius="standard"
    >
      <Box
        background={disabled ? "neutral-700" : "jets-black"}
        borderRadius="standard"
        display="flex"
        cursor={disabled ? "not-allowed" : "pointer"}
        onClick={() => !disabled && onSelect(product)}
        flexDirection="column"
      >
        <Hidden above="mobile">
          <HotDealCardBody
            height={HOT_DEAL_CARD_HEIGHT}
            lines={priceDescription ? "3" : "5"}
            title={product.title}
            description={description}
            priceDescription={priceDescription}
            disabled={disabled}
          />
        </Hidden>
        <Hidden below="tablet">
          <Hidden above="tablet">
            <HotDealCardBody
              height={HOT_DEAL_CARD_HEIGHT - 5}
              lines={priceDescription ? "3" : "5"}
              title={product.title}
              description={description}
              priceDescription={priceDescription}
              disabled={disabled}
            />
          </Hidden>
        </Hidden>
        <Hidden below="desktop">
          <HotDealCardBody
            height={HOT_DEAL_CARD_HEIGHT - 10}
            lines={priceDescription ? "3" : "5"}
            title={product.title}
            description={description}
            priceDescription={priceDescription}
            disabled={disabled}
          />
        </Hidden>
      </Box>
    </Box>
  );
}

function HotDealCardBody(props: {
  height: number;
  truncateTitle?: boolean;
  title: string;
  description: string;
  lines: "2" | "3" | "4" | "5";
  priceDescription: string;
  disabled?: boolean;
}) {
  const textColor: Color | undefined = props.disabled
    ? "neutral-400"
    : "overPrimary";

  return (
    <div
      style={{
        height: props.height,
      }}
      className={styles.hotDealCardBody}
    >
      <div>
        <Text
          size="large"
          weight="strong"
          font="accent"
          transform="uppercase"
          truncate={props.truncateTitle}
          clamped={props.truncateTitle ? undefined : "2"}
          color={textColor}
        >
          {props.title}
        </Text>
      </div>
      <div
        style={{
          display: "flex",
          flex: 1,
        }}
      >
        <div>
          <Text clamped={props.lines} priority="low" color={textColor}>
            {props.description}
          </Text>
        </div>
      </div>
      {props.priceDescription && (
        <div style={{ flex: 0 }}>
          <Text
            color={props.disabled ? "neutral-400" : "jets-red"}
            size="xlarge"
            weight="strong"
            font="accent"
            transform="uppercase"
          >
            {props.priceDescription}
          </Text>
        </div>
      )}
    </div>
  );
}

export function HotDealCardSkeleton() {
  return (
    <div style={{ borderRadius: 6 }}>
      <Skeleton width={"100%"} height={120} />
    </div>
  );
}
